import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import Cart from '../cart';
import CheckoutForm from './form';
import QuickView from '../quickView';
import { addCart } from '../cart/actions';
import SauceyLogo from 'images/saucey.svg';
import Banner from 'components/banner';

let CheckoutPage = class CheckoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { quickViewProduct: null, hasBanner: false };
    this.openQuickView = this.openQuickView.bind(this);
    this.closeQuickView = this.closeQuickView.bind(this);
    this.addToCart = this.addToCart.bind(this);
  }

  openQuickView(product) {
    this.setState({ quickViewProduct: product });
  }

  closeQuickView() {
    this.setState({ quickViewProduct: null });
  }

  addToCart(product, qty) {
    return this.props.addCart(product, qty, { checkout: true });
  }

  handleBannerMessage(message) {
    if (!!message && !this.state.hasBanner) this.setState({ hasBanner: true });
    if (!message && this.state.hasBanner) this.setState({ hasBanner: false });
  }

  render() {
    return (
      <div
        className={
          'checkout-page' +
          (this.state.hasBanner ? ' checkout-page--with-banner' : '')
        }
      >
        <div className="checkout-page__container">
          <div className="row center-xs start-md">
            <div className="col-xs-12 col-md-offset-3 col-md-9">
              <div className="checkout-page__header">
                <a href="/" className="checkout-page__logo">
                  <img src={SauceyLogo} />
                </a>
              </div>
            </div>
          </div>

          <Banner
            checkout={true}
            onMessageChange={message => this.handleBannerMessage(message)}
          />

          <div className="checkout-page__cart-container">
            <Cart openQuickView={this.openQuickView} />
          </div>

          <div className="row">
            <div className="col-xs-12 col-md-offset-3 col-md-9">
              <CheckoutForm openQuickView={this.openQuickView} />
            </div>
          </div>
        </div>

        <QuickView
          product={this.state.quickViewProduct}
          changeProduct={this.openQuickView}
          addToCart={this.addToCart}
          close={this.closeQuickView}
        />
      </div>
    );
  }
};

CheckoutPage = connect(() => ({}), { addCart })(CheckoutPage);

export default CheckoutPage;



// WEBPACK FOOTER //
// ./shared/components/checkoutPage/index.js